import { SERVICE_TYPE } from '~../__queries__/globalTypes';

type GetVatRateArgs = {
  categoryId: string;
  categoriesWithUkVatRate: CategoriesWithUkVatRate[];
  itemVatRate: number;
  serviceType: SERVICE_TYPE | null;
};

export type CategoriesWithUkVatRate = {
  id: string;
  ukVatRate: number;
};

export const getVatRate = ({
  categoryId,
  categoriesWithUkVatRate,
  itemVatRate,
  serviceType,
}: GetVatRateArgs) => {
  const isTakeAway = serviceType === SERVICE_TYPE.TAKE_AWAY;
  const category = categoriesWithUkVatRate.find((c) => c.id === categoryId);

  if (!category) {
    return itemVatRate;
  }

  const ukVatRate = category.ukVatRate;

  if (isTakeAway && ukVatRate !== null) {
    return ukVatRate;
  }

  return itemVatRate;
};
